import Button from 'rsuite/Button';
import { badgeClasses } from 'util/AlertToUIBadge';
import moment from 'moment';

const AlertPreview = (props) => {
  const { data } = props;

  const onClickHandler = (e) => {
    // console.log(123);
    if (!props.onClickHadler) return;
    props.onClickHadler(e);
  };

  return (
    <div className={`single-alert ${data.level}`} onClick={onClickHandler}>
      <div className={`d-flex justify-content-between align-items-center`}>
        <div className='alert-message'>
          <Button appearance='subtle' className='p-0'>
            <span className={badgeClasses[data.level] + ' badge-default'}>
              {data.message}
            </span>
          </Button>
        </div>
        <div className='alert-date'>{moment(data.date).calendar()}</div>
      </div>
      {props.children}
    </div>
  );
};

export default AlertPreview;
